// ISQ (initial suggested questions) slice. useMessageHistory and QueryLayerBlock each publish
// one field; see .claude/context/store-slices.md ("suggestionsSlice").
export const suggestionsSlice = (set) => ({
  isSuggestedQuestionsLoading: false,
  wereQuestionsGenerated: false,
  setIsSuggestedQuestionsLoading: (value) => set({ isSuggestedQuestionsLoading: value }),
  setWereQuestionsGenerated: (value) => set({ wereQuestionsGenerated: value }),
});
